import EngageSpotSquare from '@assets/img/others/engagespot-square.png';
import { AuthHeading } from 'components/auth/AuthComponents';
import Default from 'layouts/auth/types/Default';
import { Link } from 'react-router-dom';

function SignUpDefault() {
  return (
    <Default
      maincard={
        <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
          <div className="mt-[10vh] w-full max-w-full flex-col md:pl-4 lg:pl-0 xl:max-w-[420px]">
            <img className="relative bottom-14" src={EngageSpotSquare} alt="" />
            <AuthHeading text="Signups are closed" />
            <p className="mt-2 text-lg text-gray-10">
              We are not accepting new signups at this time.
            </p>
            <p className="mt-4 text-base text-gray-400">
              Already have an account?{' '}
              <Link
                to="/auth/login"
                className="text-yellow-450 hover:text-yellow-600"
              >
                Sign in here
              </Link>
              .
            </p>
          </div>
        </div>
      }
    />
  );
}

export default SignUpDefault;
